import type React from "react";
import type {ContractDetail, ContractDocument, ContractVersion} from "../contractExplorerTypes.ts";
import {termOf} from "../contractExplorerFormat.ts";
import {FactValue} from "./FactValue.tsx";

export type Term = {field: string; label: string; format?: (value: unknown) => string};

type Props = {
    contract: ContractDetail;
    version: ContractVersion | undefined;
    documents: Record<string, ContractDocument>;
    terms: Term[];
};

/** Terms as label → value rows; a term no document states reads as a dash. */
export const TermList: React.FC<Props> = ({contract, version, documents, terms}) => (
    <div className="ci-card ci-clauses">
        {terms.map(term => {
            const fact = termOf(contract, version, term.field);
            return (
                <div key={term.field} className={`ci-clause${fact ? ' on' : ''}`}>
                    <span className="l">{term.label}</span>
                    <span className="v"><FactValue fact={fact} documents={documents} format={term.format}/></span>
                </div>
            );
        })}
    </div>
);
